//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiClientConfig {
  public defaultHeaders: { [key: string]: any } = {};
}

export class BaseApiClient {
  private apiClientConfig: ApiClientConfig;

  constructor(apiClientConfig: ApiClientConfig) {
    this.apiClientConfig = apiClientConfig;
  }

  protected getBaseUrl(_: string, baseUrl = urlReplacer): string {
    return baseUrl;
  }

  protected transformOptions(requestConfig: RequestInit): Promise<RequestInit> {
    requestConfig.credentials = "include";

    if (requestConfig.headers == null)
      requestConfig.headers = new Headers();

    for (const headerKey in this.apiClientConfig.defaultHeaders) {
      Reflect.set(
        requestConfig.headers,
        headerKey,
        this.apiClientConfig.defaultHeaders[headerKey]
      );
    }

    return Promise.resolve(requestConfig);
  }

  protected parseJsonObject(response: string) {
    try {
      // @ts-ignore
      const jsonObject = JSON.parse(response, this.jsonParseReviver);
      if (typeof jsonObject !== "object")
        return undefined;

      return jsonObject;
    }
    catch {
      return undefined;
    }
  }

  protected async transformResult<T>(
    url: string,
    response: Response,
    processFn: (r: Response) => Promise<T>
  ): Promise<T> {
    return processFn(response)
      .catch(ex => {
        if (ex != null &&
          // @ts-ignore
          ApiException.isApiException(ex)
        ) {
          if (ex.status === 403) {
            const http403Message = 'HTTP 403. Access denied';
            ex.message = http403Message;
            ex.result = {
              ErrorCode: ex.status,
              ErrorMessage: http403Message,
              Parameters: {
                'url': response.url
              }
            };
          }
          else if (ex.response != null && ex.response.length > 0) {
            if (ex.status === 204) {
              return null as unknown as T;
            }
            const responseAsJson = this.parseJsonObject(ex.response);
            ex.result = responseAsJson;

            if (responseAsJson != null && responseAsJson.ErrorMessage != null) {
              ex.message = responseAsJson.ErrorMessage;
            }
          }
        }

        throw ex;
      });
  }
}

export class Client extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get account info
     * @return OK
     */
    getAccountInfo(): Promise<AccountInfo> {
        let url_ = this.baseUrl + "/Account/GetAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountInfo(_response));
        });
    }

    protected processGetAccountInfo(response: Response): Promise<AccountInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccountInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountInfo>(null as any);
    }

    /**
     * Get user's authorization
     * @return OK
     */
    getUserAuthorization(): Promise<UserAuthorization> {
        let url_ = this.baseUrl + "/Account/GetUserAuthorization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserAuthorization(_response));
        });
    }

    protected processGetUserAuthorization(response: Response): Promise<UserAuthorization> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserAuthorization;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAuthorization>(null as any);
    }

    /**
     * Get industries
     * @return OK
     */
    getIndustries(): Promise<Industry[]> {
        let url_ = this.baseUrl + "/Account/GetIndustries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIndustries(_response));
        });
    }

    protected processGetIndustries(response: Response): Promise<Industry[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Industry[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Industry[]>(null as any);
    }

    /**
     * Get account admins
     * @return OK
     */
    getAccountAdmins(): Promise<UserInfo[]> {
        let url_ = this.baseUrl + "/Account/GetAccountAdmins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountAdmins(_response));
        });
    }

    protected processGetAccountAdmins(response: Response): Promise<UserInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo[]>(null as any);
    }

    /**
     * Get account users
     * @return OK
     */
    getAccountUsers(): Promise<UserInfo[]> {
        let url_ = this.baseUrl + "/Account/GetAccountUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountUsers(_response));
        });
    }

    protected processGetAccountUsers(response: Response): Promise<UserInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo[]>(null as any);
    }

    /**
     * Get account groups
     * @return OK
     */
    getAccountGroups(): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/Account/GetAccountGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccountGroups(_response));
        });
    }

    protected processGetAccountGroups(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(null as any);
    }

    /**
     * Save account info
     * @param body (optional) 
     * @return OK
     */
    saveAccountInfo(body: AccountInfo | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Account/SaveAccountInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAccountInfo(_response));
        });
    }

    protected processSaveAccountInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds users to assigned groups
     * @param body (optional) 
     * @return OK
     */
    addUsersToGroups(body: AddUsersToGroupsRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Account/AddUsersToGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddUsersToGroups(_response));
        });
    }

    protected processAddUsersToGroups(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update account logo picture
     * @param file (optional) 
     * @return OK
     */
    updateAccountLogo(file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Account/UpdateAccountLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAccountLogo(_response));
        });
    }

    protected processUpdateAccountLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove account logo picture
     * @return OK
     */
    removeAccountLogo(): Promise<void> {
        let url_ = this.baseUrl + "/Account/RemoveAccountLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveAccountLogo(_response));
        });
    }

    protected processRemoveAccountLogo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get account billing info (billing/shipping addresses)
     * @return OK
     */
    getBillingInfo(): Promise<BillingInfo> {
        let url_ = this.baseUrl + "/Billing/GetBillingInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBillingInfo(_response));
        });
    }

    protected processGetBillingInfo(response: Response): Promise<BillingInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BillingInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingInfo>(null as any);
    }

    /**
     * Update billing information
     * @param body (optional) 
     * @return OK
     */
    updateBillingInfo(body: BillingInfo | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Billing/UpdateBillingInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateBillingInfo(_response));
        });
    }

    protected processUpdateBillingInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload tax exemption certificate via send form data
     * @param image (optional) 
     * @return OK
     */
    uploadExemptionCertificate(image: FileParameter | undefined): Promise<CertificateInfo> {
        let url_ = this.baseUrl + "/Billing/UploadExemptionCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (image === null || image === undefined)
            throw new Error("The parameter 'image' cannot be null.");
        else
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadExemptionCertificate(_response));
        });
    }

    protected processUploadExemptionCertificate(response: Response): Promise<CertificateInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CertificateInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateInfo>(null as any);
    }

    /**
     * Gets credit cards
     * @return OK
     */
    getCards(): Promise<PaymentMethod[]> {
        let url_ = this.baseUrl + "/Finance/GetCards";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCards(_response));
        });
    }

    protected processGetCards(response: Response): Promise<PaymentMethod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentMethod[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethod[]>(null as any);
    }

    /**
     * Sets card as default one
     * @param body (optional) 
     * @return OK
     */
    setDefaultCard(body: SetDefaultCardRequest | undefined): Promise<CreditCardEvent> {
        let url_ = this.baseUrl + "/Finance/SetDefaultCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetDefaultCard(_response));
        });
    }

    protected processSetDefaultCard(response: Response): Promise<CreditCardEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCardEvent;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditCardEvent>(null as any);
    }

    /**
     * Adds a card
     * @param body (optional) 
     * @return OK
     */
    addCard(body: AddCreditCardRequest | undefined): Promise<CreditCardEvent> {
        let url_ = this.baseUrl + "/Finance/AddCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCard(_response));
        });
    }

    protected processAddCard(response: Response): Promise<CreditCardEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCardEvent;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditCardEvent>(null as any);
    }

    /**
     * Edits a card
     * @param body (optional) 
     * @return OK
     */
    editCard(body: EditCreditCardRequest | undefined): Promise<CreditCardEvent> {
        let url_ = this.baseUrl + "/Finance/EditCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditCard(_response));
        });
    }

    protected processEditCard(response: Response): Promise<CreditCardEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCardEvent;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditCardEvent>(null as any);
    }

    /**
     * Finalizes 3DS check
     * @param cardId (optional) 
     * @return OK
     */
    finalize3DSCheck(cardId: string | undefined): Promise<CreditCardEvent> {
        let url_ = this.baseUrl + "/Finance/Finalize3DSCheck?";
        if (cardId === null)
            throw new Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFinalize3DSCheck(_response));
        });
    }

    protected processFinalize3DSCheck(response: Response): Promise<CreditCardEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreditCardEvent;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditCardEvent>(null as any);
    }

    /**
     * Removes the card
     * @param cardId (optional) 
     * @return OK
     */
    removeCard(cardId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Finance/RemoveCard?";
        if (cardId === null)
            throw new Error("The parameter 'cardId' cannot be null.");
        else if (cardId !== undefined)
            url_ += "cardId=" + encodeURIComponent("" + cardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveCard(_response));
        });
    }

    protected processRemoveCard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds new bank account as a payment option
     * @param body (optional) 
     * @return OK
     */
    saveBankAccount(body: SaveBankAccountRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Finance/SaveBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveBankAccount(_response));
        });
    }

    protected processSaveBankAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns a list of linked bank accounts
     * @return OK
     */
    listBankAccounts(): Promise<BankAccountPaymentMethod[]> {
        let url_ = this.baseUrl + "/Finance/ListBankAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListBankAccounts(_response));
        });
    }

    protected processListBankAccounts(response: Response): Promise<BankAccountPaymentMethod[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankAccountPaymentMethod[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountPaymentMethod[]>(null as any);
    }

    /**
     * Sets default bank account
     * @param body (optional) 
     * @return OK
     */
    setDefaultBankAccount(body: SetDefaultBankAccountRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Finance/SetDefaultBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetDefaultBankAccount(_response));
        });
    }

    protected processSetDefaultBankAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get an allocation for the individual license
     * @param licenseId (optional) 
     * @return OK
     */
    getIndividualAllocation(licenseId: string | undefined): Promise<IndividualLicenseAllocation> {
        let url_ = this.baseUrl + "/IndividualLicenseAllocations/GetIndividualAllocation?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetIndividualAllocation(_response));
        });
    }

    protected processGetIndividualAllocation(response: Response): Promise<IndividualLicenseAllocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndividualLicenseAllocation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndividualLicenseAllocation>(null as any);
    }

    /**
     * Get available users to save as an assignee for the individual license
     * @param licenseId (optional) 
     * @return OK
     */
    getUsersAssignableToIndividualLicense(licenseId: string | undefined): Promise<UserInfo[]> {
        let url_ = this.baseUrl + "/IndividualLicenseAllocations/GetUsersAssignableToIndividualLicense?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsersAssignableToIndividualLicense(_response));
        });
    }

    protected processGetUsersAssignableToIndividualLicense(response: Response): Promise<UserInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo[]>(null as any);
    }

    /**
     * Saves the allocation for the individual license
     * @param body (optional) 
     * @return OK
     */
    saveIndividualAllocation(body: SaveIndividualAllocationRequest | undefined): Promise<IndividualLicenseAllocation> {
        let url_ = this.baseUrl + "/IndividualLicenseAllocations/SaveIndividualAllocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveIndividualAllocation(_response));
        });
    }

    protected processSaveIndividualAllocation(response: Response): Promise<IndividualLicenseAllocation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IndividualLicenseAllocation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndividualLicenseAllocation>(null as any);
    }

    /**
     * @return OK
     */
    getAllInvoicesForCustomer(): Promise<Invoice[]> {
        let url_ = this.baseUrl + "/Invoices/GetAllInvoicesForCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllInvoicesForCustomer(_response));
        });
    }

    protected processGetAllInvoicesForCustomer(response: Response): Promise<Invoice[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Invoice[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice[]>(null as any);
    }

    /**
     * @param type (optional) 
     * @return OK
     */
    getLayoutContent(type: string | undefined): Promise<LayoutContent> {
        let url_ = this.baseUrl + "/GetLayoutContent?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLayoutContent(_response));
        });
    }

    protected processGetLayoutContent(response: Response): Promise<LayoutContent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LayoutContent;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayoutContent>(null as any);
    }

    /**
     * Get list of allocations for license
     * @param licenseId (optional) 
     * @return OK
     */
    getAllocations(licenseId: string | undefined): Promise<ListOfAllocations> {
        let url_ = this.baseUrl + "/LicenseAllocations/GetAllocations?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllocations(_response));
        });
    }

    protected processGetAllocations(response: Response): Promise<ListOfAllocations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListOfAllocations;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListOfAllocations>(null as any);
    }

    /**
     * Get allocation details for Manage Allocation dialog
     * @param licenseId (optional) 
     * @param allocationId (optional) 
     * @return OK
     */
    getAllocationForEdit(licenseId: string | undefined, allocationId: string | undefined): Promise<AllocationManagement> {
        let url_ = this.baseUrl + "/LicenseAllocations/GetAllocationForEdit?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        if (allocationId === null)
            throw new Error("The parameter 'allocationId' cannot be null.");
        else if (allocationId !== undefined)
            url_ += "allocationId=" + encodeURIComponent("" + allocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllocationForEdit(_response));
        });
    }

    protected processGetAllocationForEdit(response: Response): Promise<AllocationManagement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllocationManagement;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllocationManagement>(null as any);
    }

    /**
     * Get allocation details for New Allocation dialog
     * @param licenseId (optional) 
     * @return OK
     */
    getAllocationForCreate(licenseId: string | undefined): Promise<AllocationManagement> {
        let url_ = this.baseUrl + "/LicenseAllocations/GetAllocationForCreate?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllocationForCreate(_response));
        });
    }

    protected processGetAllocationForCreate(response: Response): Promise<AllocationManagement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AllocationManagement;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllocationManagement>(null as any);
    }

    /**
     * Save new or modified license allocation
     * @param body (optional) 
     * @return OK
     */
    saveAllocation(body: AllocationManagement | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LicenseAllocations/SaveAllocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveAllocation(_response));
        });
    }

    protected processSaveAllocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete license allocation
     * @param body (optional) 
     * @return OK
     */
    deleteAllocation(body: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LicenseAllocations/DeleteAllocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAllocation(_response));
        });
    }

    protected processDeleteAllocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get groups with license allocations
     * @return OK
     */
    getGroupsWithAllocations(): Promise<UserGroup[]> {
        let url_ = this.baseUrl + "/LicenseAllocations/GetGroupsWithAllocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetGroupsWithAllocations(_response));
        });
    }

    protected processGetGroupsWithAllocations(response: Response): Promise<UserGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserGroup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroup[]>(null as any);
    }

    /**
     * Gets list of all requests
     * @return OK
     */
    getLicenseRequests(): Promise<LicenseRequestInfo[]> {
        let url_ = this.baseUrl + "/LicenseRequests/GetLicenseRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLicenseRequests(_response));
        });
    }

    protected processGetLicenseRequests(response: Response): Promise<LicenseRequestInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseRequestInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseRequestInfo[]>(null as any);
    }

    /**
     * Gets list of requests for a specific license
     * @param licenseId (optional) 
     * @param requestType (optional) 
     * @return OK
     */
    getRequestsForLicense(licenseId: string | undefined, requestType: LicenseRequestType | undefined): Promise<LicenseRequestList[]> {
        let url_ = this.baseUrl + "/LicenseRequests/GetRequestsForLicense?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequestsForLicense(_response));
        });
    }

    protected processGetRequestsForLicense(response: Response): Promise<LicenseRequestList[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseRequestList[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseRequestList[]>(null as any);
    }

    /**
     * Gets list of license access requests
     * @return OK
     */
    getLicenseAccessRequests(): Promise<LicenseRequestList[]> {
        let url_ = this.baseUrl + "/LicenseRequests/GetLicenseAccessRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLicenseAccessRequests(_response));
        });
    }

    protected processGetLicenseAccessRequests(response: Response): Promise<LicenseRequestList[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseRequestList[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseRequestList[]>(null as any);
    }

    /**
     * Sets status of provided requests to Acknowledged
     * @param body (optional) 
     * @return OK
     */
    acknowledgeRequests(body: RejectRequestsCommand | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LicenseRequests/AcknowledgeRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAcknowledgeRequests(_response));
        });
    }

    protected processAcknowledgeRequests(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send Trade Up Notification Request
     * @param licenseId (optional) 
     * @return OK
     */
    sendTrade(licenseId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/LicenseRequests/SendTrade?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSendTrade(_response));
        });
    }

    protected processSendTrade(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the list of add seat requests grouped by users
     * @return OK
     */
    getAddSeatRequests(): Promise<AddSeatNotification[]> {
        let url_ = this.baseUrl + "/LicenseRequests/GetAddSeatRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAddSeatRequests(_response));
        });
    }

    protected processGetAddSeatRequests(response: Response): Promise<AddSeatNotification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddSeatNotification[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddSeatNotification[]>(null as any);
    }

    /**
     * Get account list of licenses
     * @return OK
     */
    getLicenses(): Promise<ListOfLicenses> {
        let url_ = this.baseUrl + "/Licenses/GetLicenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLicenses(_response));
        });
    }

    protected processGetLicenses(response: Response): Promise<ListOfLicenses> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListOfLicenses;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListOfLicenses>(null as any);
    }

    /**
     * Get archived licenses
     * @return OK
     */
    getArchivedLicenses(): Promise<LicenseGroup[]> {
        let url_ = this.baseUrl + "/Licenses/GetArchivedLicenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetArchivedLicenses(_response));
        });
    }

    protected processGetArchivedLicenses(response: Response): Promise<LicenseGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseGroup[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseGroup[]>(null as any);
    }

    /**
     * Get license information
     * @param licenseId (optional) 
     * @return OK
     */
    getLicenseInfo(licenseId: string | undefined): Promise<LicenseFull> {
        let url_ = this.baseUrl + "/Licenses/GetLicenseInfo?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLicenseInfo(_response));
        });
    }

    protected processGetLicenseInfo(response: Response): Promise<LicenseFull> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseFull;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseFull>(null as any);
    }

    /**
     * Get license information details (section 'License Details')
     * @param licenseId (optional) 
     * @return OK
     */
    getLicenseDetails(licenseId: string | undefined): Promise<LicenseDetails> {
        let url_ = this.baseUrl + "/Licenses/GetLicenseDetails?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLicenseDetails(_response));
        });
    }

    protected processGetLicenseDetails(response: Response): Promise<LicenseDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDetails>(null as any);
    }

    /**
     * Get options to filter the list of licenses
     * @return OK
     */
    getLicenseFilterOptions(): Promise<LicenseFilterOptions> {
        let url_ = this.baseUrl + "/Licenses/GetLicenseFilterOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLicenseFilterOptions(_response));
        });
    }

    protected processGetLicenseFilterOptions(response: Response): Promise<LicenseFilterOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicenseFilterOptions;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseFilterOptions>(null as any);
    }

    /**
     * Get number of assigned users for licenses
     * @param body (optional) 
     * @return OK
     */
    getUsersAssignedCount(body: string[] | undefined): Promise<UsersAssignedCount[]> {
        let url_ = this.baseUrl + "/Licenses/GetUsersAssignedCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsersAssignedCount(_response));
        });
    }

    protected processGetUsersAssignedCount(response: Response): Promise<UsersAssignedCount[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsersAssignedCount[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsersAssignedCount[]>(null as any);
    }

    /**
     * Get brief information for adding seat(s) to license
     * @param licenseId (optional) 
     * @return OK
     */
    getAddSeatInfo(licenseId: string | undefined): Promise<AddSeatInfo> {
        let url_ = this.baseUrl + "/Licenses/GetAddSeatInfo?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAddSeatInfo(_response));
        });
    }

    protected processGetAddSeatInfo(response: Response): Promise<AddSeatInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddSeatInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddSeatInfo>(null as any);
    }

    /**
     * Get preview information for add seat(s) to license when user has specified number of seats to add
     * @param licenseId (optional) 
     * @param numberOfSeats (optional) 
     * @return OK
     */
    previewAddSeat(licenseId: string | undefined, numberOfSeats: number | undefined): Promise<AddSeatPreview> {
        let url_ = this.baseUrl + "/Licenses/PreviewAddSeat?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        if (numberOfSeats === null)
            throw new Error("The parameter 'numberOfSeats' cannot be null.");
        else if (numberOfSeats !== undefined)
            url_ += "numberOfSeats=" + encodeURIComponent("" + numberOfSeats) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewAddSeat(_response));
        });
    }

    protected processPreviewAddSeat(response: Response): Promise<AddSeatPreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddSeatPreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddSeatPreview>(null as any);
    }

    /**
     * Get preview information for upgrade license's geo scope
     * @param licenseId (optional) 
     * @return OK
     */
    previewUpgradeGeoScope(licenseId: string | undefined): Promise<UpgradeGeoScopePreview> {
        let url_ = this.baseUrl + "/Licenses/PreviewUpgradeGeoScope?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreviewUpgradeGeoScope(_response));
        });
    }

    protected processPreviewUpgradeGeoScope(response: Response): Promise<UpgradeGeoScopePreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpgradeGeoScopePreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpgradeGeoScopePreview>(null as any);
    }

    /**
     * Get brief information for Activate License operation
     * @param licenseId (optional) 
     * @return OK
     */
    getActivationInfo(licenseId: string | undefined): Promise<ActivationInfo> {
        let url_ = this.baseUrl + "/Licenses/GetActivationInfo?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivationInfo(_response));
        });
    }

    protected processGetActivationInfo(response: Response): Promise<ActivationInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivationInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivationInfo>(null as any);
    }

    /**
     * Get activation link for license
     * @param body (optional) 
     * @return OK
     */
    getActivationUrl(body: ActivateRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Licenses/GetActivationUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivationUrl(_response));
        });
    }

    protected processGetActivationUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get Licenses Available To User
     * @return OK
     */
    getUserLicenses(): Promise<ListOfLicenses> {
        let url_ = this.baseUrl + "/Licenses/GetUserLicenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserLicenses(_response));
        });
    }

    protected processGetUserLicenses(response: Response): Promise<ListOfLicenses> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListOfLicenses;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListOfLicenses>(null as any);
    }

    /**
     * Update license notification contact
     * @param body (optional) 
     * @return OK
     */
    updateNotificationContact(body: UpdateNotificationContactRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Licenses/UpdateNotificationContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateNotificationContact(_response));
        });
    }

    protected processUpdateNotificationContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get licenses summary info (expiring soon, seat limit reached)
     * @return OK
     */
    getSummaryInfo(): Promise<LicensesSummaryInfo> {
        let url_ = this.baseUrl + "/Licenses/GetSummaryInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSummaryInfo(_response));
        });
    }

    protected processGetSummaryInfo(response: Response): Promise<LicensesSummaryInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicensesSummaryInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicensesSummaryInfo>(null as any);
    }

    /**
     * @return OK
     */
    getAvailablePaymentMethods(): Promise<PaymentMethodType[]> {
        let url_ = this.baseUrl + "/PaymentMethods/GetAvailablePaymentMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailablePaymentMethods(_response));
        });
    }

    protected processGetAvailablePaymentMethods(response: Response): Promise<PaymentMethodType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaymentMethodType[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodType[]>(null as any);
    }

    /**
     * @return OK
     */
    getBankAccountLinkToken(): Promise<BankAccountPublicLinkToken> {
        let url_ = this.baseUrl + "/PaymentMethods/GetBankAccountLinkToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBankAccountLinkToken(_response));
        });
    }

    protected processGetBankAccountLinkToken(response: Response): Promise<BankAccountPublicLinkToken> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BankAccountPublicLinkToken;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountPublicLinkToken>(null as any);
    }

    /**
     * @return OK
     */
    getCountries(): Promise<Country[]> {
        let url_ = this.baseUrl + "/Regions/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCountries(_response));
        });
    }

    protected processGetCountries(response: Response): Promise<Country[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Country[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Country[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @return OK
     */
    getStates(countryCode: string | undefined): Promise<State[]> {
        let url_ = this.baseUrl + "/Regions/GetStates?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStates(_response));
        });
    }

    protected processGetStates(response: Response): Promise<State[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as State[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<State[]>(null as any);
    }

    /**
     * Gets summary content for 'Real Time Usage' report
     * @return OK
     */
    realTimeUsageReportSummary(): Promise<RealTimeUsageInfo> {
        let url_ = this.baseUrl + "/Reports/RealTimeUsageReportSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRealTimeUsageReportSummary(_response));
        });
    }

    protected processRealTimeUsageReportSummary(response: Response): Promise<RealTimeUsageInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RealTimeUsageInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealTimeUsageInfo>(null as any);
    }

    /**
     * Gets summary content for 'Real Time Usage' report as CSV file
     * @return OK
     */
    realTimeUsageReportToCsv(): Promise<void> {
        let url_ = this.baseUrl + "/Reports/RealTimeUsageReportToCsv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRealTimeUsageReportToCsv(_response));
        });
    }

    protected processRealTimeUsageReportToCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets detailed content for the license for 'Real Time Usage' report
     * @param licenseId (optional) 
     * @param timeOffsetInMinutes (optional) 
     * @return OK
     */
    realTimeUsageReportDetails(licenseId: string | undefined, timeOffsetInMinutes: number | undefined): Promise<RealTimeUsageDetails> {
        let url_ = this.baseUrl + "/Reports/RealTimeUsageReportDetails?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "LicenseId=" + encodeURIComponent("" + licenseId) + "&";
        if (timeOffsetInMinutes === null)
            throw new Error("The parameter 'timeOffsetInMinutes' cannot be null.");
        else if (timeOffsetInMinutes !== undefined)
            url_ += "TimeOffsetInMinutes=" + encodeURIComponent("" + timeOffsetInMinutes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRealTimeUsageReportDetails(_response));
        });
    }

    protected processRealTimeUsageReportDetails(response: Response): Promise<RealTimeUsageDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RealTimeUsageDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealTimeUsageDetails>(null as any);
    }

    /**
     * Releases the active lease
     * @param body (optional) 
     * @return OK
     */
    forceReleaseLicenseLease(body: string | undefined): Promise<ForceReleaseResult> {
        let url_ = this.baseUrl + "/Reports/ForceReleaseLicenseLease";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForceReleaseLicenseLease(_response));
        });
    }

    protected processForceReleaseLicenseLease(response: Response): Promise<ForceReleaseResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForceReleaseResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForceReleaseResult>(null as any);
    }

    /**
     * Queues multiple active leases to be released
     * @param licenseId (optional) 
     * @param body (optional) 
     * @return OK
     */
    queueForceReleaseLicenseLeases(licenseId: string | undefined, body: QueueReleaseLicenseLeasesRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Reports/QueueForceReleaseLicenseLeases?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQueueForceReleaseLicenseLeases(_response));
        });
    }

    protected processQueueForceReleaseLicenseLeases(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets content for 'Usage Log' report
     * @param body (optional) 
     * @return OK
     */
    usageLogReport(body: UsageLogRequest | undefined): Promise<UsageLogInfo> {
        let url_ = this.baseUrl + "/Reports/UsageLogReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsageLogReport(_response));
        });
    }

    protected processUsageLogReport(response: Response): Promise<UsageLogInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsageLogInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsageLogInfo>(null as any);
    }

    /**
     * Gets content for 'Usage Log' report as CSV file
     * @param body (optional) 
     * @return OK
     */
    usageLogReportToCsv(body: UsageLogRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Reports/UsageLogReportToCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsageLogReportToCsv(_response));
        });
    }

    protected processUsageLogReportToCsv(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets content for 'Usage History' report
     * @param body (optional) 
     * @return OK
     */
    usageHistoryReport(body: UsageHistoryRequest | undefined): Promise<UsageHistoryInfo> {
        let url_ = this.baseUrl + "/Reports/UsageHistoryReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsageHistoryReport(_response));
        });
    }

    protected processUsageHistoryReport(response: Response): Promise<UsageHistoryInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UsageHistoryInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsageHistoryInfo>(null as any);
    }

    /**
     * Gets content for 'Usage History' report as CSV file
     * @param body (optional) 
     * @return OK
     */
    usageHistoryReportToCsv(body: UsageHistoryRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/Reports/UsageHistoryReportToCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsageHistoryReportToCsv(_response));
        });
    }

    protected processUsageHistoryReportToCsv(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get capacity report
     * @param body (optional) 
     * @return OK
     */
    realTimeCapacity(body: CapacityReportRequest | undefined): Promise<RealTimeCapacity> {
        let url_ = this.baseUrl + "/Reports/RealTimeCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRealTimeCapacity(_response));
        });
    }

    protected processRealTimeCapacity(response: Response): Promise<RealTimeCapacity> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RealTimeCapacity;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RealTimeCapacity>(null as any);
    }

    /**
     * Creates a Setup Intent
     * @param body (optional) 
     * @return OK
     */
    startSetup(body: SetupStartRequest | undefined): Promise<SetupIntentInfo> {
        let url_ = this.baseUrl + "/Stripe/StartSetup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartSetup(_response));
        });
    }

    protected processStartSetup(response: Response): Promise<SetupIntentInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetupIntentInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetupIntentInfo>(null as any);
    }

    /**
     * Finalizes a Setup Intent
     * @param body (optional) 
     * @return OK
     */
    finalizeSetup(body: SetupFinalizeRequest | undefined): Promise<SetupFinalizeResult> {
        let url_ = this.baseUrl + "/Stripe/FinalizeSetup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFinalizeSetup(_response));
        });
    }

    protected processFinalizeSetup(response: Response): Promise<SetupFinalizeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetupFinalizeResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetupFinalizeResult>(null as any);
    }

    /**
     * Gets all subscriptions
     * @return OK
     */
    getSubscriptions(): Promise<SubscriptionInfo[]> {
        let url_ = this.baseUrl + "/Subscriptions/GetSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubscriptions(_response));
        });
    }

    protected processGetSubscriptions(response: Response): Promise<SubscriptionInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionInfo[]>(null as any);
    }

    /**
     * Cancels the specified subscription
     * @param subscriptionId (optional) 
     * @return OK
     */
    cancelSubscription(subscriptionId: string | undefined): Promise<SubscriptionState> {
        let url_ = this.baseUrl + "/Subscriptions/CancelSubscription?";
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelSubscription(_response));
        });
    }

    protected processCancelSubscription(response: Response): Promise<SubscriptionState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubscriptionState;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionState>(null as any);
    }

    /**
     * Get information about all paid workspaces
     * @return OK
     */
    getWorkspacesInfo(): Promise<WorkspaceInfo[]> {
        let url_ = this.baseUrl + "/Subscriptions/GetWorkspacesInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkspacesInfo(_response));
        });
    }

    protected processGetWorkspacesInfo(response: Response): Promise<WorkspaceInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkspaceInfo[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkspaceInfo[]>(null as any);
    }

    /**
     * Gets custom subscription upgrade URL based on account shipping address
     * @return OK
     */
    getSubscriptionUpgradeUrl(): Promise<string> {
        let url_ = this.baseUrl + "/Subscriptions/GetSubscriptionUpgradeUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSubscriptionUpgradeUrl(_response));
        });
    }

    protected processGetSubscriptionUpgradeUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets user subscription level
     * @return OK
     */
    getUserSubscriptionLevel(): Promise<number> {
        let url_ = this.baseUrl + "/Subscriptions/GetUserSubscriptionLevel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUserSubscriptionLevel(_response));
        });
    }

    protected processGetUserSubscriptionLevel(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Sends an upgrade subscription request
     * @param body (optional) 
     * @return OK
     */
    requestUpgradeSubscription(body: RequestUpgradeSubscriptionRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Subscriptions/RequestUpgradeSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRequestUpgradeSubscription(_response));
        });
    }

    protected processRequestUpgradeSubscription(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface AccountInfo {
    id: string | undefined;
    name: string | undefined;
    isIndividualLicenseExists: boolean;
    phone: string | undefined;
    website: string | undefined;
    fax: string | undefined;
    description: string | undefined;
    industry: string | undefined;
    userId: string | undefined;
    accountLogoUrl: string | undefined;
    isPublic: boolean;
    allowDisplayUsers: boolean;
    lastModifiedAt: string | undefined;
    isAltium: boolean;
    advancedSecurityPackages: string[] | undefined;
}

export interface ActivateRequest {
    licenseId: string | undefined;
    productId: number;
    isPrimary: boolean;
}

export interface ActivationInfo {
    clientVersions: ClientVersion[] | undefined;
    showPrimarySecondarySelector: boolean;
}

export interface AddCreditCardRequest {
    workspaceId: string | undefined;
    paymentIntentId: string | undefined;
    creditCard: CreditCard;
}

export interface AddSeatInfo {
    subscriptionLevelName: string | undefined;
    currentSeats: number;
    pricePerSeat: number;
    currencyCode: string | undefined;
}

export interface AddSeatNotification {
    requestId: string | undefined;
    user: UserInfo;
    license: LicenseShort;
    createdAt: string;
}

export interface AddSeatPreview {
    currencyCode: string | undefined;
    pricePerSeatYear: number;
    numberOfSeatsToAdd: number;
    totalPriceYear: number;
    paymentPeriodDays: number;
    dueNow: number;
}

export interface AddUsersToGroupsRequest {
    usersGroupsMap: { [key: string]: string; } | undefined;
}

export interface Address {
    address1: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryAlpha2Code: string | undefined;
}

export interface AddressInfo {
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    countryCode: string | undefined;
}

export interface Allocation {
    id: string | undefined;
    groupId: string | undefined;
    groupName: string | undefined;
    seatCount: number;
    allAvailableSeats: boolean;
}

export interface AllocationManagement {
    id: string | undefined;
    licenseId: string | undefined;
    groupId: string | undefined;
    seatCount: number;
    allAvailableSeats: boolean;
    licenseSettings: LicenseSettings;
    notificationSettings: NotificationSettings;
    groups: Group[] | undefined;
}

export interface BankAccountPaymentMethod {
    id: string | undefined;
    bankName: string | undefined;
    mask: string | undefined;
    isDefault: boolean;
}

export interface BankAccountPublicLinkToken {
    token: string | undefined;
}

export interface BillingInfo {
    billingAddress: Address;
    phone: string | undefined;
    shippingAddress: Address;
    vat: string | undefined;
    taxExemptionCode: string | undefined;
}

export interface CalculatedValue {
    name: string | undefined;
    value: number;
    oldValue: number;
    state: CalculatedValueState;
    type: CalculatedValueType;
}

export enum CalculatedValueState {
    Success = "Success",
    Warning = "Warning",
    Error = "Error",
    Unspecified = "Unspecified",
    Default = "Default",
}

export enum CalculatedValueType {
    Number = "Number",
    Money = "Money",
    Percentage = "Percentage",
    Hours = "Hours",
}

export interface CapacityChartInfo {
    items: CapacityItem[] | undefined;
    rejectionsTotal: number;
    rejectionsAveragePerDay: number;
    totalHours: number;
    productivityAveragePerDay: number;
    financialLoss: number;
    projectDeliveryDelay: number;
}

export interface CapacityItem {
    date: string;
    type: CapacityTimeRanges;
    licenseLease: number;
    licenseAccessRejection: number;
    lostProductivityItem: number;
    availableSeats: number;
}

export interface CapacityLicenseAllocation {
    id: string | undefined;
    serialNumber: string | undefined;
    title: string | undefined;
    seats: number;
    allocations: ListOfAllocations;
}

export interface CapacityRecommendation {
    title: string | undefined;
    readonly sortOrder: number;
    roi: number;
    type: CapacityRecommendationType;
    estimatedProductivityIncreasePercentage: number;
    estimatedDeliveryIncreasePercentage: number;
    values: CalculatedValue[] | undefined;
    linkToStore: string | undefined;
    licenses: string[] | undefined;
    licenseSerials: string[] | undefined;
}

export enum CapacityRecommendationType {
    Default = "Default",
    BestValue = "BestValue",
    HighestImpact = "HighestImpact",
}

export interface CapacityReportRequest {
    dateStart: string;
    dateEnd: string;
    accountId: string | undefined;
}

export interface CapacitySummary {
    values: CalculatedValue[] | undefined;
}

export enum CapacityTimeRanges {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export enum CardType {
    Visa = "Visa",
    MasterCard = "MasterCard",
    AmericanExpress = "AmericanExpress",
    Discover = "Discover",
    Jcb = "Jcb",
    DinersClub = "DinersClub",
    Bancontact = "Bancontact",
    Other = "Other",
}

export interface CertificateInfo {
    link: string | undefined;
}

export interface ClientVersion {
    id: number;
    versionName: string | undefined;
    productName: string | undefined;
}

export interface Country {
    name: string | undefined;
    alpha2Code: string | undefined;
    alpha3Code: string | undefined;
    currencyCode: string | undefined;
    entityId: string | undefined;
    addressFormat: string | undefined;
    stripeTaxIdType: string | undefined;
    taxBlockType: TaxBlockType;
    isUnderSanctions: boolean;
    subscriptionUpgradeUrl: string | undefined;
    readonly blackListedRequestTypes: number[] | undefined;
}

export interface CreditCard {
    number: string | undefined;
    cvv: string | undefined;
    expiryYear: number;
    expiryMonth: number;
    cardholderName: string | undefined;
    line1: string | undefined;
    line2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    countryAlpha2Code: string | undefined;
}

export interface CreditCardEvent {
    cardId: string | undefined;
    result: boolean;
    redirectTo3DSUrl: string | undefined;
}

export interface CustomerInfo {
    organizationName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phone: string | undefined;
    vat: string | undefined;
    taxExemptionCode: string | undefined;
    billingAddress: AddressInfo;
    shippingAddress: AddressInfo;
    billingSameAsShipping: boolean;
}

export enum DashboardPermission {
    SubscriptionEdit = "SubscriptionEdit",
    LicenseListView = "LicenseListView",
    LicenseView = "LicenseView",
    LicenseAddSeat = "LicenseAddSeat",
    LicenseRenew = "LicenseRenew",
    LicenseContactEdit = "LicenseContactEdit",
    LicenseTradeUp = "LicenseTradeUp",
    LicenseTradeUpRequest = "LicenseTradeUpRequest",
    LicenseUpgradeGeoScope = "LicenseUpgradeGeoScope",
    LicenseReleaseSeat = "LicenseReleaseSeat",
    LicenseActivate = "LicenseActivate",
    LicenseListArchived = "LicenseListArchived",
    LicenseAllocationsView = "LicenseAllocationsView",
    LicenseAllocationsEdit = "LicenseAllocationsEdit",
    LicenseRequestsView = "LicenseRequestsView",
    LicenseRequestsEdit = "LicenseRequestsEdit",
    CompanyProfileView = "CompanyProfileView",
    CompanyProfileEdit = "CompanyProfileEdit",
    BillingInfoView = "BillingInfoView",
    BillingInfoEdit = "BillingInfoEdit",
    PaymentMethodsView = "PaymentMethodsView",
    PaymentMethodsEdit = "PaymentMethodsEdit",
    InvoiceListView = "InvoiceListView",
    ReportRealTimeUsage = "ReportRealTimeUsage",
    ReportUsageHistory = "ReportUsageHistory",
    ReportUsageLog = "ReportUsageLog",
    ReportRealTimeCapacity = "ReportRealTimeCapacity",
}

export interface EditCreditCardRequest {
    workspaceId: string | undefined;
    paymentIntentId: string | undefined;
    creditCardId: string | undefined;
    creditCard: CreditCard;
}

export interface ForceReleaseResult {
    leaseId: string | undefined;
    errorMessage: string | undefined;
    readonly isSuccess: boolean;
}

export interface GeoScopeInfo {
    id: string | undefined;
    description: string | undefined;
}

export interface Group {
    id: string | undefined;
    name: string | undefined;
    usersCount: number | undefined;
}

export interface IndividualLicenseAllocation {
    user: UserInfo;
}

export interface Industry {
    id: number;
    title: string | undefined;
    name: string | undefined;
}

export interface Invoice {
    id: string | undefined;
    number: string | undefined;
    amount: number;
    currencyCode: string | undefined;
    transactionDate: string | undefined;
    status: string | undefined;
    attachmentUrl: string | undefined;
}

export interface LayoutContent {
    data: string | undefined;
    success: boolean;
    dataServer: string | undefined;
    dataServerProfile: string | undefined;
}

export interface License {
    id: string | undefined;
    expirationDate: string;
    serialNumber: string | undefined;
    activationCode: string | undefined;
    isTimeBased: boolean;
    seatCount: number;
    productName: string | undefined;
    licenseTypeId: string | undefined;
    licenseTypeName: string | undefined;
    licenseUsageId: string | undefined;
    licenseUsageName: string | undefined;
    geoScopeId: string | undefined;
    geoScopeName: string | undefined;
    isActive: boolean;
    iconUrl: string | undefined;
    permissionSetName: string | undefined;
    permissionSetFamilyName: string | undefined;
    isIndividual: boolean;
    queryCount: number | undefined;
    viewAttributes: { [key: string]: any; } | undefined;
    readonly canAddSeat: boolean;
    readonly canUpgradeGeoScope: boolean;
    readonly canActivate: boolean;
    readonly canRenew: boolean;
    readonly canTradeUp: boolean;
    readonly canManageAllocations: boolean;
    readonly canViewDetails: boolean;
    readonly tradeUpUrl: string | undefined;
}

export interface LicenseDetails {
    startDate: string;
    expirationDate: string;
    seatCount: number;
    activationCode: string | undefined;
    licenseTypeName: string | undefined;
    licenseTermName: string | undefined;
    notificationContact: UserInfo;
}

export interface LicenseFilterOptions {
    licenceTypeOptions: { [key: string]: string; } | undefined;
    geoScopeOptions: { [key: string]: string; } | undefined;
}

export interface LicenseFull {
    id: string | undefined;
    expirationDate: string;
    serialNumber: string | undefined;
    activationCode: string | undefined;
    isTimeBased: boolean;
    seatCount: number;
    productName: string | undefined;
    licenseTypeId: string | undefined;
    licenseTypeName: string | undefined;
    licenseUsageId: string | undefined;
    licenseUsageName: string | undefined;
    geoScopeId: string | undefined;
    geoScopeName: string | undefined;
    isActive: boolean;
    iconUrl: string | undefined;
    permissionSetName: string | undefined;
    permissionSetFamilyName: string | undefined;
    isIndividual: boolean;
    queryCount: number | undefined;
    viewAttributes: { [key: string]: any; } | undefined;
    readonly canAddSeat: boolean;
    readonly canUpgradeGeoScope: boolean;
    readonly canActivate: boolean;
    readonly canRenew: boolean;
    readonly canTradeUp: boolean;
    readonly canManageAllocations: boolean;
    readonly canViewDetails: boolean;
    readonly tradeUpUrl: string | undefined;
    subscriptionPlan: string | undefined;
    renewUrlByCard: string | undefined;
    renewUrlByInvoice: string | undefined;
    upgradeBenefitsPage: string | undefined;
    upgradePlanUrl: string | undefined;
}

export interface LicenseGroup {
    name: string | undefined;
    licenses: License[] | undefined;
}

export interface LicenseRequest {
    requestId: string | undefined;
    licenseId: string | undefined;
    user: UserInfo;
    createdAt: string;
    type: LicenseRequestType;
}

export interface LicenseRequestInfo {
    licenseId: string | undefined;
    renewRequestCount: number;
    addSeatRequestCount: number;
    groupAccessRequestCount: number;
    tradeUpRequestCount: number;
}

export interface LicenseRequestList {
    user: UserInfo;
    requests: LicenseRequest[] | undefined;
}

export enum LicenseRequestType {
    Renew = "Renew",
    AddSeat = "AddSeat",
    Access = "Access",
    TradeUp = "TradeUp",
}

export interface LicenseSettings {
    automaticLeasing: boolean;
    allowRoaming: boolean;
    maxRoamingDurationHours: number;
    canManageLeaseVerificationInterval: boolean;
    releaseInactiveSeats: boolean;
    leaseVerificationIntervalHours: number;
}

export interface LicenseShort {
    id: string | undefined;
    serialNumber: string | undefined;
    productName: string | undefined;
    iconUrl: string | undefined;
}

export interface LicensesSummaryInfo {
    expiringSoonCount: number;
    seatLimitReachedCount: number;
}

export interface ListOfAllocations {
    groupAllocations: Allocation[] | undefined;
    groups: Group[] | undefined;
}

export interface ListOfLicenses {
    totalLicensesCount: number;
    activeLicenses: LicenseGroup[] | undefined;
    inactiveLicenses: LicenseGroup[] | undefined;
    subscriptionLevelId: number;
    subscriptionLevelName: string | undefined;
}

export interface NotificationSettings {
    rejectNotifications: boolean;
    warningNotifications: boolean;
    warningPercentage: number;
    notifyUserGroupId: string | undefined;
}

export interface PaymentMethod {
    id: string | undefined;
    lastFourDigits: string | undefined;
    expiryYear: number;
    expiryMonth: number;
    firstName: string | undefined;
    lastName: string | undefined;
    cardType: CardType;
    isDefault: boolean;
}

export enum PaymentMethodType {
    CreditCard = "CreditCard",
    BankTransfer = "BankTransfer",
    Klarna = "Klarna",
}

export interface ProjectedPayment {
    currencyCode: string | undefined;
    amount: number;
    nextPaymentDate: string;
}

export interface QueueReleaseLicenseLeasesRequest {
    leaseIds: string[] | undefined;
    timeOffsetInMinutes: number;
}

export interface RealTimeCapacity {
    capacitySummary: CapacitySummary;
    recommendations: CapacityRecommendation[] | undefined;
    licenseAllocations: CapacityLicenseAllocation[] | undefined;
    detailedReport: CapacityChartInfo;
    userRejections: UserRejection[] | undefined;
    licenseIds: string[] | undefined;
}

export interface RealTimeUsageDetails {
    licenseId: string | undefined;
    leases: RealTimeUsageLeaseInfo[] | undefined;
}

export interface RealTimeUsageInfo {
    licenses: RealTimeUsageLicenseInfo[] | undefined;
    allGroups: UserGroup[] | undefined;
    seatsTotal: number;
    uniqueUsers: number;
    exportToCsvUrl: string | undefined;
}

export interface RealTimeUsageLeaseInfo {
    leaseId: string | undefined;
    userId: string | undefined;
    userName: string | undefined;
    userEmail: string | undefined;
    groupId: string | undefined;
    groupName: string | undefined;
    startTime: string;
    expiryTime: string | undefined;
    returnedTime: string | undefined;
    readonly usedHours: number | undefined;
}

export interface RealTimeUsageLicenseInfo {
    licenseId: string | undefined;
    productName: string | undefined;
    productIcon: string | undefined;
    activationCode: string | undefined;
    seatsTotal: number;
    seatsUsed: number;
    activeUsers: number;
    seatsUsageThreshold: number | undefined;
    userGroupMap: UserGroupMap[] | undefined;
}

export interface RejectRequestsCommand {
    requests: string[] | undefined;
}

export interface RequestUpgradeSubscriptionRequest {
    phone: string | undefined;
    email: string | undefined;
    accountId: string | undefined;
}

export interface SaveBankAccountRequest {
    accountId: string | undefined;
    publicToken: string | undefined;
}

export interface SaveIndividualAllocationRequest {
    licenseId: string | undefined;
    licenseUserId: string | undefined;
}

export interface SetDefaultBankAccountRequest {
    accountId: string | undefined;
}

export interface SetDefaultCardRequest {
    creditCardId: string | undefined;
}

export interface SetupFinalizeRequest {
    entityId: string | undefined;
    setupIntentId: string | undefined;
    isNewCustomer: boolean;
    newCustomer: CustomerInfo;
}

export interface SetupFinalizeResult {
}

export interface SetupIntentInfo {
    accountExists: boolean;
    entityId: string | undefined;
    clientSecret: string | undefined;
    publishableKey: string | undefined;
    customerExternalId: string | undefined;
}

export interface SetupStartRequest {
    countryCode: string | undefined;
}

export interface State {
    countryCode: string | undefined;
    stateCode: string | undefined;
    stateName: string | undefined;
}

export interface SubscriptionInfo {
    id: string | undefined;
    bundleId: number;
    bundleName: string | undefined;
    paymentTerm: SubscriptionPaymentTerm;
    state: SubscriptionState;
    startDate: string;
    endDate: string | undefined;
    adUsers: number | undefined;
}

export enum SubscriptionPaymentTerm {
    Yearly = "Yearly",
    Monthly = "Monthly",
    Weekly = "Weekly",
    Daily = "Daily",
}

export enum SubscriptionState {
    Incomplete = "Incomplete",
    Expired = "Expired",
    InTrial = "InTrial",
    Active = "Active",
    PastDue = "PastDue",
    Cancelled = "Cancelled",
    Unpaid = "Unpaid",
    Paused = "Paused",
}

export enum TaxBlockType {
    None = "None",
    Vat = "Vat",
    Gst = "Gst",
    TaxExempt = "TaxExempt",
}

export interface UpdateNotificationContactRequest {
    licenseId: string | undefined;
    contactId: string | undefined;
}

export interface UpgradeGeoScopePreview {
    subscriptionLevelId: number;
    currencyCode: string | undefined;
    paymentPeriodDays: number;
    expiryDate: string;
    seatCount: number;
    details: UpgradeGeoScopePreviewDetails[] | undefined;
    geoScopes: GeoScopeInfo[] | undefined;
}

export interface UpgradeGeoScopePreviewDetails {
    geoScopeId: string | undefined;
    geoScopeName: string | undefined;
    proRatedPricePerSeat: number;
    priceTotalDueNow: number;
}

export enum UsageHistoryDateGroupEnum {
    Year = "Year",
    Quarter = "Quarter",
    Month = "Month",
    Week = "Week",
    Day = "Day",
}

export enum UsageHistoryGroupField {
    License = "License",
    User = "User",
    Group = "Group",
}

export interface UsageHistoryInfo {
    items: UsageHistoryItem[] | undefined;
    hasMoreItems: boolean;
}

export interface UsageHistoryItem {
    productName: string | undefined;
    activationCode: string | undefined;
    userName: string | undefined;
    lastName: string | undefined;
    firstName: string | undefined;
    groupName: string | undefined;
    year: number;
    quarter: number | undefined;
    month: number | undefined;
    week: number | undefined;
    day: number | undefined;
    days: number | undefined;
    minutesUsed: number;
    avgWorkMinutes: number;
    usage: number;
    userGroups: UserGroup[] | undefined;
}

export interface UsageHistoryRequest {
    licenseGuids: string[] | undefined;
    userGuids: string[] | undefined;
    allocatedViaGroupGuids: string[] | undefined;
    groupGuids: string[] | undefined;
    dateStart: string | undefined;
    dateEnd: string | undefined;
    workingHours: number | undefined;
    groupByDate: UsageHistoryDateGroupEnum;
    groupFields: UsageHistoryGroupField[] | undefined;
    sortField: UsageHistorySortField;
    sortDesc: boolean;
    from: number;
    count: number;
}

export enum UsageHistorySortField {
    License = "License",
    DateRange = "DateRange",
    AvgWorkTime = "AvgWorkTime",
}

export interface UsageLogInfo {
    items: UsageLogItem[] | undefined;
    hasMoreItems: boolean;
}

export interface UsageLogItem {
    licenseGuid: string | undefined;
    productName: string | undefined;
    productIcon: string | undefined;
    activationCode: string | undefined;
    adVersion: string | undefined;
    userGuid: string | undefined;
    userName: string | undefined;
    userEmail: string | undefined;
    userIcon: string | undefined;
    groupGuid: string | undefined;
    groupName: string | undefined;
    userGroups: UserGroup[] | undefined;
    startTime: string;
    endTime: string;
    durationText: string | undefined;
}

export interface UsageLogRequest {
    licenseGuids: string[] | undefined;
    userGuids: string[] | undefined;
    allocatedViaGroupGuids: string[] | undefined;
    groupGuids: string[] | undefined;
    dateStart: string | undefined;
    dateEnd: string | undefined;
    sortField: UsageLogSortField;
    sortDesc: boolean;
    timeOffsetInMinutes: number;
    from: number;
    count: number;
}

export enum UsageLogSortField {
    StartTime = "StartTime",
    Version = "Version",
}

export interface UserAuthorization {
    sessionIdHash: string | undefined;
    isAccessRestricted: boolean;
    permissions: DashboardPermission[] | undefined;
}

export interface UserGroup {
    id: string | undefined;
    name: string | undefined;
}

export interface UserGroupMap {
    userId: string | undefined;
    groupId: string | undefined;
}

export interface UserInfo {
    id: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    profileUrl: string | undefined;
    profilePictureUrl: string | undefined;
    email: string | undefined;
    lastLoginDate: string;
    groups: UserGroup[] | undefined;
}

export interface UserRejection {
    userId: string | undefined;
    userName: string | undefined;
    hoursLost: number;
    rejectionCount: number;
    seatPurchaseRequests: number;
    groups: UserGroup[] | undefined;
}

export interface UsersAssignedCount {
    licenseId: string | undefined;
    count: number;
}

export interface WorkspaceInfo {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    owner: UserInfo;
    memberCount: number;
    region: string | undefined;
    projectedPayment: ProjectedPayment;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

const urlReplacer = "<BASE_URL>";